import React, { Fragment, useCallback, useContext, useState } from 'react';
import { Name, Age, MobileNo, EmailAddress, History, Edit, Delete, Print, General } from '../../../../Constant';
import { H5, H6, Image, LI, P, UL } from '../../../../AbstractElements';
import ContactAppContext from '../../../../_helper/Contact';
import SearchNotFoundClass from './SearchNotFoundClass';
import PrintModal from './PrintModal';
import SweetAlert from 'sweetalert2';
import PromiseSpinner from '../../../../CommonElements/Spinner/PromiseSpinner';
import { trackPromise } from 'react-promise-tracker';
import { ProductListDesc, pinagareFilesUpload, pinagareAPIURL } from '../../../../Constant';
import { ToastContainer, toast } from "react-toastify";
import { useNavigate, Link, useParams } from 'react-router-dom';

const ContactDetailsClass = ({ eng, userEditCallback, selectedUser, editurl, imgUpdate }) => {

    //const [selectedUser, setSelectedUser] = useState(supervisor);
    const [printmodal, setPrintModal] = useState(false);
    const printModalToggle = () => setPrintModal(!printmodal);
    const { deletedUser } = useContext(ContactAppContext);
    const history = useNavigate();

    const toggleCallback = useCallback((toggle) => {
        setPrintModal(toggle);
    });

    //const history = () => {
       // document.querySelector('.history').classList.add('show');
    //};

    const EditUSers = (usersData) => {
        userEditCallback(true, usersData, usersData.avatar);
    };

    const deleteUser = (userId,employee_id) => {

        SweetAlert.fire({
            title: 'Are you sure you want to delete this supervisor?',
            text: 'Once deleted, the supervisor can no longer perform their duties on this platform!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'Cancel',
            reverseButtons: true
        }).then((result) => {

            if (result.value) {

                //deletedUser(userId);

                const body_t=JSON.stringify({
        
                    omang:localStorage.getItem('username'),
                    eng:'delete_pinagare_supervisor',
                    item_id:userId, 
                    employee_id:employee_id,      
                    
                  });

                trackPromise(
                    pinagareSendRequest(pinagareAPIURL,body_t,userId)
                );  
                
            } else {
                SweetAlert.fire(
                    'Supervisor not deleted!'
                );
            }
        });
    };

    async function pinagareSendRequest(url,body,userId) {//alert('d');
    
        try {
          
          await fetch(url, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            body: body,
          })
            .then((respose) => {
              if (respose.ok) {
            
                return respose.json()
              }
              throw new Error('error')
            })
            .then((data) => {
      
            //alert(eng);
            
              if (data.status!=null&&data.status!=undefined&&data.status) {
      
              
                SweetAlert.fire(
                    'Deleted!',
                    'The supervisor has been deleted successfully.',
                    'success'
                );
                    
                //update supervisors object here
                //const data = selectedUser.filter(item => userId !== item.id);
                //setSelectedUser(null);
                history(`${process.env.PUBLIC_URL}/dpsm/home/manage-supervisors`); 
                             
              } else {
                
      
                if(data.status==false){
    
                    toast.error(data.message);
                  
                }
                else{             
                  
                    toast.error(" Network Error occurred... Could not delete data.");
                
                }
               
               
    
              }
            })
            //.then((error) => {//alert(JSON.stringify(error));
           // })
      
         
        } catch (error) {
          //console.log(JSON.stringify(error)+" --"); 
          toast.error("Network Error occurred.. Could not delete data.."+JSON.stringify(error));
         
        }
      
      }

    return (
        <Fragment>
            {selectedUser ?
                <div className="profile-mail">
                    <div className="media">
                        <Image attrImage={{ className: 'img-100 img-fluid m-r-20 rounded-circle update_img_0', src: `${require(`../../../../assets/images/user/user.png`)}`, alt: '' }} />
                        <div className="media-body mt-0">
                            <H5><span className="first_name_0">{selectedUser.firstname}</span> <span className="last_name_0">{selectedUser.surname}</span></H5>
                            <P attrPara={{ className: 'email_add_0' }} >{selectedUser.email_address}</P>
                            <UL attrUL={{ className: 'flex-row' }}>
                                  <LI><a href="#javaScript" onClick={() => deleteUser(selectedUser.id,selectedUser.employee_id)}>{"Delete"}</a></LI>
                              </UL>
                        </div>
                    </div>
                    <div className="email-general">
                        <H6 >{"Details"}</H6>
                       
                            <P attrLI={{ className: 'border-0' }}>{"Omang:"} <span className="font-primary">{selectedUser.employee_id}</span></P>
                            <P attrLI={{ className: 'border-0' }}>{"Cellphone:"} <span className="font-primary mobile_num_0">{selectedUser.cellphone_number}</span></P>
                            <P attrLI={{ className: 'border-0' }}>{"Email Address:"} <span className="font-primary email_add_0">{`${selectedUser.email_address}`} </span></P>
                            
                            {eng=='ps_approver'?<P attrLI={{ className: 'border-0' }}>{"Ministry:"} <span className="font-primary email_add_0">{`${selectedUser.ministry_full_name}`} </span>
                            </P>:eng=='committee_approver'? <P attrLI={{ className: 'border-0' }}>{"Position:"} <span className="font-primary email_add_0">{`${selectedUser.position_name}`} </span>
                            </P> : null
                            }
                        
                    </div>
                </div>
                :
                <SearchNotFoundClass />
            }
            {selectedUser &&
                <PrintModal toggleCallback={toggleCallback} printmodal={printmodal} selectedUser={selectedUser} />
            }
        </Fragment>
    );
};

export default ContactDetailsClass;